export const options = [
	{
		key: 1,
		header: "Animal Sciences",
		child: [
			{
				key: "dis",
				value: "Animal Sciences"
			},
			{
				key: "Aquaculture",
				value: "Aquaculture"
			},
			{
				key: "Animal science",
				value: "Animal science"
			},
			{
				key: "Animal breeding",
				value: "Animal breeding"
			},
			{
				key: "Animal nutrition",
				value: "Animal nutrition"
			}
		]
	},
	{
		key: 2,
		header: "Earth Sciences",
		child: [
			{
				key: "dis",
				value: "Earth Sciences"
			},
			{
				key: "Ecology",
				value: "Ecology"
			},
			{
				key: "Environmental science",
				value: "Environmental science"
			},
			{
				key: "Geology",
				value: "Geology"
			},
			{
				key: "Soil science",
				value: "Soil science"
			}
		]
	},
	{
		key: 3,
		header: "Engineering",
		child: [
			{
				key: "dis",
				value: "Engineering"
			},
			{
				key: "Engineering",
				value: "Engineering"
			}
		]
	},
	{
		key: 4,
		header: "Medicine & Public Health",
		child: [
			{
				key: "dis",
				value: "Medicine & Public Health"
			},
			{
				key: "Medical",
				value: "Medical"
			},
			{
				key: "Pharmaceutical",
				value: "Pharmaceutical"
			},
			{
				key: "Public health",
				value: "Public health"
			}
		]
	},
	{
		key: 5,
		header: "Plant Sciences",
		child: [
			{
				key: "dis",
				value: "Plant Sciences"
			},
			{
				key: "Agriculture",
				value: "Agriculture"
			},
			{
				key: "Forestry",
				value: "Forestry"
			},
			{
				key: "Horticulture",
				value: "Horticulture"
			},
			{
				key: "Plant breeding",
				value: "Plant breeding"
			}
		]
	},
	{
		key: 6,
		header: "Social Sciences",
		child: [
			{
				key: "dis",
				value: "Social Sciences"
			},
			{
				key: "Business and Management",
				value: "Business and Management"
			},
			{
				key: "Education",
				value: "Education"
			},
			{
				key: "Economics",
				value: "Economics"
			}
		]
	},
	{
		key: 7,
		header: "Other",
		child: [
			{
				key: "dis",
				value: "Other"
			},

			{ key: "Other", value: "Other" }
		]
	}
]

export const options1 = [
	{
		key: 1,
		header: "Animal Sciences",
		child: [
			{
				key: "dis",
				value: "Animal Sciences"
			},
			{
				key: "Aquaculture",
				value: "Aquaculture"
			},
			{
				key: "Animal science",
				value: "Animal science"
			},
			{
				key: "Animal breeding",
				value: "Animal breeding"
			},
			{
				key: "Animal nutrition",
				value: "Animal nutrition"
			}
		]
	},
	{
		key: 2,
		header: "Earth Sciences",
		child: [
			{
				key: "dis",
				value: "Earth Sciences"
			},
			{
				key: "Ecology",
				value: "Ecology"
			},
			{
				key: "Environmental science",
				value: "Environmental science"
			},
			{
				key: "Geology",
				value: "Geology"
			},
			{
				key: "Soil science",
				value: "Soil science"
			}
		]
	},
	{
		key: 3,
		header: "Engineering",
		child: [
			{
				key: "dis",
				value: "Engineering"
			},
			{
				key: "Engineering",
				value: "Engineering"
			}
		]
	},
	{
		key: 4,
		header: "Medicine & Public Health",
		child: [
			{
				key: "dis",
				value: "Medicine & Public Health"
			},
			{
				key: "Medical",
				value: "Medical"
			},
			{
				key: "Pharmaceutical",
				value: "Pharmaceutical"
			},
			{
				key: "Public health",
				value: "Public health"
			}
		]
	},
	{
		key: 5,
		header: "Plant Sciences",
		child: [
			{
				key: "dis",
				value: "Plant Sciences"
			},
			{
				key: "Agriculture",
				value: "Agriculture"
			},
			{
				key: "Forestry",
				value: "Forestry"
			},
			{
				key: "Horticulture",
				value: "Horticulture"
			},
			{
				key: "Plant breeding",
				value: "Plant breeding"
			}
		]
	},
	{
		key: 6,
		header: "Social Sciences",
		child: [
			{
				key: "dis",
				value: "Social Sciences"
			},
			{
				key: "Business and Management",
				value: "Business and Management"
			},
			{
				key: "Education",
				value: "Education"
			},
			{
				key: "Economics",
				value: "Economics"
			}
		]
	}
]

export const imageResearchArea = [
	{
		researcharea: "Animal Sciences",
		image: [
			"./Image Research Area/Animal Sciences/1.jpg",
			"./Image Research Area/Animal Sciences/2.jpg",
			"./Image Research Area/Animal Sciences/3.jpg",
			"./Image Research Area/Animal Sciences/4.jpg"
		]
	},
	{
		researcharea: "Earth Sciences",
		image: [
			"./Image Research Area/Earth Sciences/1.jpg",
			"./Image Research Area/Earth Sciences/2.jpg",
			"./Image Research Area/Earth Sciences/3.jpg",
			"./Image Research Area/Earth Sciences/4.jpg"
		]
	},
	{
		researcharea: "Engineering",
		image: [
			"./Image Research Area/Engineering/1.jpg",
			"./Image Research Area/Engineering/2.jpg",
			"./Image Research Area/Engineering/3.jpg",
			"./Image Research Area/Engineering/4.jpg"
		]
	},
	{
		researcharea: "Medicine & Public Health",
		image: [
			"./Image Research Area/Medicine & Public Health/1.jpg",
			"./Image Research Area/Medicine & Public Health/2.jpg",
			"./Image Research Area/Medicine & Public Health/3.jpg",
			"./Image Research Area/Medicine & Public Health/4.jpg"
		]
	},
	{
		researcharea: "Plant Sciences",
		image: [
			"./Image Research Area/Plant Sciences/1.jpg",
			"./Image Research Area/Plant Sciences/2.jpg",
			"./Image Research Area/Plant Sciences/3.jpg",
			"./Image Research Area/Plant Sciences/4.jpg"
		]
	},
	{
		researcharea: "Social Sciences",
		image: [
			"./Image Research Area/Social Sciences/1.jpg",
			"./Image Research Area/Social Sciences/2.jpg",
			"./Image Research Area/Social Sciences/3.jpg",
			"./Image Research Area/Social Sciences/4.jpg"
		]
	},
	{
		researcharea: "Other",
		image: [
			"./Image Research Area/Other/1.jpg",
			"./Image Research Area/Other/2.jpg",
			"./Image Research Area/Other/3.jpg",
			"./Image Research Area/Other/4.jpg",
			"./Image Research Area/Other/5.jpg",
			"./Image Research Area/Other/6.jpg"
		]
	}
]

export const constResearchArea = [
	{
		header: "Animal Sciences",
		child: [
			"Aquaculture",
			"Animal science",
			"Animal breeding",
			"Animal nutrition"
		]
	},
	{
		header: "Earth Sciences",
		child: ["Ecology", "Environmental science", "Geology", "Soil science"]
	},
	{
		header: "Engineering",
		child: ["Engineering"]
	},
	{
		header: "Medicine & Public Health",
		child: ["Medical", "Pharmaceutical", "Public health"]
	},
	{
		header: "Plant Sciences",
		child: ["Agriculture", "Forestry", "Horticulture", "Plant breeding"]
	},
	{
		header: "Social Sciences",
		child: ["Business and Management", "Education", "Economics"]
	},
	{
		header: "Other",
		child: ["Other"]
	}
]
